import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Optional, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable, Subject, Subscription, map, of, take, takeUntil } from 'rxjs';
import { Section } from '../../../editor-container/editor-model';
import { ContentEnum, GridCell, Product } from '@urbannex/storethemes';
import { OfbizListService,OfbizListComponent,ColumnFieldTitle, OfbizList, RemoteFormData } from '@urbannex/ofbiz-forms';
import { getColumnFieldTitles, getFields } from '@urbannex/view-containers';
import { PROD_DIALOG_FORMS } from './forms';
import { NbDialogRef } from '@nebular/theme';
import { SectionBuilderStoreService } from '../../sections-editor/shared-section-builder/section-builder-store.service';

@Component({
  selector: 'kve-product-editor-dialog',
  templateUrl: './product-editor-dialog.component.html',
  styleUrls: ['./product-editor-dialog.component.scss']
})
export class ProductEditorDialogComponent implements OnInit,OnDestroy,AfterViewInit,OnChanges {
  @Input() title:string;
  @Input() section:Section;
  @Input() selectedCell:GridCell;
  @Input() mode:string;
  @Input() standAlone:boolean;
  contentEnum:ContentEnum;
  product:Product;

  selectedCell$:Subscription;

  remoteFormData:RemoteFormData;
  listForm:OfbizList;
  listOptions:any = {};
  listType:string;
  fieldOptions:any = {};
  columnFields:any = {};
  columnFieldTitles:ColumnFieldTitle[];

  state$:any;

  result:any;

  private destroy$ = new Subject<void>()

  existingProduct$:Subscription;
  listSize$: Subscription; //Observable<number>;

  productListSize$:Observable<number>;

  @Output() selectedProduct = new EventEmitter<any>();
  @ViewChild('myList') myList!: OfbizListComponent;

  constructor(
    @Optional() protected ref:NbDialogRef<ProductEditorDialogComponent>,
    private ofbizListService:OfbizListService,
    private sectionBuilderStoreService:SectionBuilderStoreService) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["standAlone"]){
      if(this.standAlone == true){
        
        this.createProductList();
      }
    }
    //Unsubscribe from the product list so that a fresh list is loaded
    if(this.existingProduct$){
      this.existingProduct$.unsubscribe();
    }
    //Ensure that the productListSize is zero to prevent
    if(this.listSize$){
      this.listSize$.unsubscribe;
    } 
    /* if(changes["selectedCell"]){
      if(this.selectedCell != undefined && this.selectedCell != null){
        this.contentEnum = this.selectedCell.contentEnum;
        this.createProductList();
      }
    } */
  }
  
  ngAfterViewInit(): void {
    this.myList.rowSelected.subscribe(rowData => {
      if(rowData != undefined && rowData != null){
        this.existingProduct$ = this.ofbizListService.getHyperlinkCell()
        .pipe(takeUntil(this.destroy$))
        .subscribe(response => {
          console.log(response)
          if(response != undefined){
            let data = response["data"]["formData"];
            let link = data["link"];
            console.log(link);
            if(!this.standAlone){
              this.selectedProduct.emit(data);
            }
            
            //this.productListSize$ = of(0);
          }
        })
      }
    })
   
       
  }
  
  ngOnInit(): void {
    console.log(this.standAlone);
    if(this.title == undefined){
      if(this.mode == "new"){
        this.title = "Create A New Product"
      }else{
        this.title = "Link Existing Product"
      }
    }
    if(this.standAlone){
      console.log("Stand alone is true");
      this.createProductList();
    }else if(this.selectedCell != undefined && this.selectedCell != null){
      this.contentEnum = this.selectedCell.contentEnum;
      this.createProductList();
    }
    
  }

  createProductList(){
    console.log("creating product list")
    const _listForm = new OfbizList({
      listType:"grid",
      fieldFormName:"",
      fieldFormLocation:"local",
      listFormName:"ListProductCategoryMembers",//"ListProducts",
      //listFormLocation:"component://product/widget/catalog/ProductForms.xml",
      listFormLocation:"component://kwikstore/widget/ProductForms.xml",
      //columnFields:getFields("ListProducts",PROD_FORMS),
      columnFields:getFields("ListProductCategoryMembers",PROD_DIALOG_FORMS),
      //columnFieldTitles:getColumnFieldTitles("ListProducts",PROD_FORMS),
      columnFieldTitles:getColumnFieldTitles("ListProductCategoryMembers",PROD_DIALOG_FORMS),
      remoteFormData:{
      formData:{
          formName:"ListProductCategoryMembers",
          formLocation:"component://kwikstore/widget/ProductForms.xml",
          listType:"grid",
          viewIndex:1,
      },
      appContext:"catalog",
      parameters:{"productCategoryId":"CATALOG1_SEARCH"}
      },
      emptyListMessage:"No products found.  Please create new or add existing."
    });

    this.listForm = _listForm;

    this.remoteFormData = this.listForm.remoteFormData;
    this.listOptions.formName = this.listForm?.listFormName;
    this.listOptions.entityName = this.listForm?.entityName;
    this.listOptions.formLocation = this.listForm?.listFormLocation;
    this.listOptions.viewIndex = this.listForm?.viewIndex;
    this.listOptions.endPoint = this.listForm?.endPoint;
    if(this.listForm?.columnFields){
      this.columnFields = this.listForm.columnFields;
    }
    if(this.listForm.labelColumn){
      this.listOptions.labelColumn = this.listForm.labelColumn;
    }
    if(this.listForm.listType){
      this.remoteFormData.formData.listType = this.listForm.listType;
    }
    if(this.listForm.columnFieldTitles && this.listForm.columnFieldTitles != undefined){
      this.columnFieldTitles = this.listForm.columnFieldTitles;
      console.log({columnFieldTitles:this.columnFieldTitles})
    }
    if(this.listForm.idFieldName){
      this.listOptions.idFieldName = this.listForm.idFieldName;
    }
    if(this.listForm.linkedList){
      this.listOptions.linkedList = this.listForm.linkedList;
    }
    this.fieldOptions = this.listForm?.fieldFormFields;
    this.listOptions.viewSize = 10;
  }

  showOverview(e){
    console.log(e)
  }

  showEditDialog(e){
    console.log(e)
  }

  close(response){
    if(this.existingProduct$){
      this.existingProduct$.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
    this.ref.close(response);
  }

  ngOnDestroy(): void {
    console.log("It has been destroyed");
    this.destroy$.next();
    this.destroy$.complete();
  }


}
